import React, { Component } from 'react'
import './landingPage.css'
import { Helmet } from "react-helmet-async";
import lpEntryBtn from '../../assets/images/landingPage/lp-entry_btn.png'
import lpEntryBtnOn from '../../assets/images/landingPage/lp-entry_btn_on.png'
import lpLogo from '../../assets/images/landingPage/lp-logo.png'
import lpText from '../../assets/images/landingPage/lp-hero-text.png'
import lpServiceTitle from '../../assets/images/landingPage/lp-service-title.png'
import lpService01 from '../../assets/images/landingPage/lp-service_01.png'
import lpService02 from '../../assets/images/landingPage/lp-service_02.png'
import lpService03 from '../../assets/images/landingPage/lp-service_03.png'
import lpService04 from '../../assets/images/landingPage/lp-service_04.png'
import lpSec02_ttl from '../../assets/images/landingPage/lp-sec02_ttl.png'
import lpSec02_txt from '../../assets/images/landingPage/lp-sec02_txt.png'
import lpSec02_catch from '../../assets/images/landingPage/lp-sec02_catch.png'
import lpSec02_thumbnail from '../../assets/images/landingPage/lp-sec02_thumbnail.png'
import lpSec03_ttl from '../../assets/images/landingPage/lp-sec03_ttl.png'
import lpSec03_gender from '../../assets/images/landingPage/lp-sec03_gender.png'
import lpSec03_age from '../../assets/images/landingPage/lp-sec03_age.png'
import lpSec03_years from '../../assets/images/landingPage/lp-sec03_years.png'
import lpSec03_percentage from '../../assets/images/landingPage/lp-sec03_percentage.png'
import lpSec03_earnings from '../../assets/images/landingPage/lp-sec03_earnings.png'
import lpSec03_overtime from '../../assets/images/landingPage/lp-sec03_overtime.png'
import lpSec03_paidholidays from '../../assets/images/landingPage/lp-sec03_paidholidays.png'
import lpSec03_qualification01 from '../../assets/images/landingPage/lp-sec03_qualification01.png'
import lpSec03_qualification02 from '../../assets/images/landingPage/lp-sec03_qualification02.png'
import lpSec03_qualification03 from '../../assets/images/landingPage/lp-sec03_qualification03.png'
import lpSec04_ttl from '../../assets/images/landingPage/lp-sec04_ttl.png'
import lpSec05_ttl from '../../assets/images/landingPage/lp-sec05_ttl.png'
import lpSec05_700 from '../../assets/images/landingPage/lp-sec05_bg700.png'
import lpSec05_700time from '../../assets/images/landingPage/lp-sec05_time700.png'
import lpSec05_830 from '../../assets/images/landingPage/lp-sec05_bg830.png'
import lpSec05_830time from '../../assets/images/landingPage/lp-sec05_time830.png'
import lpSec05_1030 from '../../assets/images/landingPage/lp-sec05_bg1030.png'
import lpSec05_1030time from '../../assets/images/landingPage/lp-sec05_time1030.png'
import lpSec05_1145 from '../../assets/images/landingPage/lp-sec05_bg1145.png'
import lpSec05_1145time from '../../assets/images/landingPage/lp-sec05_time1145.png'
import lpSec05_1245 from '../../assets/images/landingPage/lp-sec05_bg1245.png'
import lpSec05_1245time from '../../assets/images/landingPage/lp-sec05_time1245.png'
import lpSec05_1730 from '../../assets/images/landingPage/lp-sec05_bg1730.png'
import lpSec05_1730time from '../../assets/images/landingPage/lp-sec05_time1730.png'
import lpSec05_1900 from '../../assets/images/landingPage/lp-sec05_bg1900.png'
import lpSec05_1900time from '../../assets/images/landingPage/lp-sec05_time1900.png'
import lpSec06_ttl from '../../assets/images/landingPage/lp-sec06_ttl.png'
import lpSec06_q from '../../assets/images/landingPage/lp-sec06_q.png'
import lpSec07_ttl from '../../assets/images/landingPage/lp-sec07_ttl.png'
import lpSec07_benefit01 from '../../assets/images/landingPage/lp-sec07_benefits01.png'
import lpSec07_benefit02 from '../../assets/images/landingPage/lp-sec07_benefits02.png'
import lpSec07_benefit03 from '../../assets/images/landingPage/lp-sec07_benefits03.png'
import lpSec07_benefit04 from '../../assets/images/landingPage/lp-sec07_benefits04.png'
import lpSec08_ttl from '../../assets/images/landingPage/lp-sec08_ttl.png'
import lpSec08_main from '../../assets/images/landingPage/lp-sec08_main.png'


class LandingPage extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>2022 新卒採用ENTRY | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                {/* <div className="lp-container"> */}
                <div id="LP-container">
                    {/* fixed entry button  */}
                    <div className="entry-btn">
                        <a href="#lp-entry" className="lp-entry-link">
                            <img src={lpEntryBtn} alt="ENTRY 募集要項" className="img-fluid is-inactive" />
                            <img src={lpEntryBtnOn} alt="ENTRY 募集要項" className="img-fluid is-active" />
                        </a>
                    </div>
                    {/* top section */}
                    <div className="top-section">
                        <div className="col-8">
                            <img src={lpLogo} alt="logo" className="img-fluid" />
                        </div>
                        <div className="row top-main-txt">
                            <div>
                                <img src={lpText} alt="top-main-text" className="img-fluid" />
                            </div>
                            <div className="top-main-subtxt lp-min">
                                <p>
                                    さまざまなビジネスシーンにおける“あったらいいな”。<br />
                                    <span className="top-main-subtxt-sp">
                                        今はまだ存在しないこのアイデアを大切に預かり、<br />
                                        形あるものへと実現させること
                                    </span>
                                    が、私たちの仕事です。<br />
                                    ソフトウェアで、企業の新しい一歩を。
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* section 1  */}
                    <div className="sec sec01">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpServiceTitle} alt="service-title" className="img-fluid" />
                                <span>NALの仕事内容</span>
                            </h2>
                            <div className="lp-service-list lp-hira">
                                <div className="row">
                                    <div className="col-6">
                                        <img src={lpService01} alt="service01" className="img-fluid" />
                                        <div className="lp-service-item-text mt-5">
                                            <h1 className="lp-service-subhead">システム開発</h1>
                                            <span>お客様のニーズを正確に把握し、システム提案から開発・導入・保守までを行います。</span>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <img src={lpService02} alt="service02" className="img-fluid" />
                                        <div className="lp-service-item-text mt-5">
                                            <h1 className="lp-service-subhead">パッケージ<br />開発・導入</h1>
                                            <span>
                                                弊社オリジナルのパッケージを販売。他社商品の導入<br />
                                                サポートも承ります。
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <img src={lpService03} alt="service03" className="img-fluid" />
                                        <div className="lp-service-item-text mt-5">
                                            <h1 className="lp-service-subhead">技術支援</h1>
                                            <span>システム開発における人材派遣を行います。検討段階からの技術者派遣も可能です。</span>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <img src={lpService04} alt="service04" className="img-fluid" />
                                        <div className="lp-service-item-text mt-5">
                                            <h1 className="lp-service-subhead">インフラ構築</h1>
                                            <span>お客様の現在の状況、資材を有効活用し、低コストでシンククライアント環境を実現します。</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 2  */}
                    <div className="sec sec02">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec02_ttl} alt="philosophy-title" className="img-fluid" />
                                <span>求める人物像</span>
                            </h2>
                            <p className="lp-philo-text">
                                <img src={lpSec02_txt} alt="philosophy-text" className="img-fluid" />
                            </p>
                            <p className="lp-philo-text">
                                <img src={lpSec02_catch} alt="philosophy-text" className="img-fluid" />
                            </p>
                            <p className="lp-philo-text">
                                <img src={lpSec02_thumbnail} alt="philosophy-text" className="img-fluid" />
                            </p>
                        </div>
                    </div>

                    {/* section 3  */}
                    <div className="sec sec03">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec03_ttl} alt="about-title" className="img-fluid" />
                                <span>数字でわかるNAL</span>
                            </h2>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">男女比率</h3>
                                <img src={lpSec03_gender} alt="card-gender" className="img-fluid" />
                            </div>
                            <div className="row justify-content-evenly">
                                <div className="col-6">
                                    <div className="sec03-card">
                                        <h3 className="sec03-card_ttl">平均年齢</h3>
                                        <img src={lpSec03_age} alt="card-age" className="about-img" />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="sec03-card">
                                        <h3 className="sec03-card_ttl">平均勤続年数</h3>
                                        <img src={lpSec03_years} alt="card-years" className="about-img" />
                                    </div>
                                </div>
                            </div>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">年代別割合</h3>
                                <img src={lpSec03_percentage} alt="card-percentage" className="img-fluid" />
                            </div>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">売上高推移</h3>
                                <img src={lpSec03_earnings} alt="card-earnings" className="img-fluid" />
                            </div>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">時間外労働平均<br />
                                    <span className="sub">（入社1年目～3年目：1ヶ月）</span>
                                </h3>
                                <img src={lpSec03_overtime} alt="card-overtime" className="img-fluid" />
                            </div>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">有給休暇取得平均<br />
                                    <span className="sub">（入社1年目～3年目）</span>
                                </h3>
                                <img src={lpSec03_paidholidays} alt="card-paidholidays" className="img-fluid" />
                            </div>
                            <div className="sec03-card">
                                <h3 className="sec03-card_ttl">有資格者（システム部）</h3>
                                <div className="row">
                                    <div className="col-8">
                                        <p className="qualification-ttl">ＩＴパスポート</p>
                                    </div>
                                    <div className="col-4">
                                        <img src={lpSec03_qualification01} alt="card-qualification01" className="img-fluid quali-img" />
                                    </div>
                                    <div className="col-8">
                                        <p className="qualification-ttl">基本情報技術者</p>
                                    </div>
                                    <div className="col-4">
                                        <img src={lpSec03_qualification02} alt="card-qualification02" className="img-fluid quali-img" />
                                    </div>
                                    <div className="col-8">
                                        <p className="qualification-ttl">応用情報技術者</p>
                                    </div>
                                    <div className="col-4">
                                        <img src={lpSec03_qualification03} alt="card-qualification03" className="img-fluid quali-img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 4 */}
                    <div className="sec sec04">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec04_ttl} alt="career-title" className="img-fluid" />
                                <span>入社後のキャリアプラン</span>
                            </h2>

                            <div className="row mt-5 mb-5">
                                <h3 className="lp-career-text">一般職</h3>
                            </div>
                            {/* orange box */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="lp-1-level lp-career-block lp-career-bg-orange">
                                        <p className="lp-career-text">担当（PG)</p>
                                    </div>
                                </div>
                                <div className="lp-node-1"></div>
                                <div className="col-12">
                                    <div className="lp-1-level lp-career-block lp-career-bg-orange">
                                        <p className="lp-career-text">担当（SE)</p>
                                    </div>
                                </div>
                            </div>
                            {/* dark orange & pink boxes  */}
                            <div className="lp-node-1"></div>
                            <div className="lp-node-2"></div>
                            <div className="row mt-3 justify-content-between">
                                <div className="col-5">
                                    <p className="lp-career-text">
                                        技術専門職 <br />
                                        <span className="lp-career-subtxt">(インフラや開発技術に特化)</span>
                                    </p>
                                </div>
                                <div className="col-5">
                                    <p className="lp-career-text">
                                        管理職<br />
                                        <span className="lp-career-subtxt">(プロジェクト統括)</span>
                                    </p>
                                </div>
                            </div>
                            <div className="row justify-content-between">
                                <div className="col-5 lp-career-block  lp-career-bg-Dorange">
                                    <p className="lp-career-text">エキスパート</p>
                                </div>
                                <div className="col-5 lp-career-block  lp-career-bg-pink">
                                    <p className="lp-career-text">
                                        L <span className="lp-career-subtxt">(リーダー)</span> <br />
                                        PGのまとめ役
                                    </p>
                                </div>
                            </div>
                            <div className="lp-node-2_1"></div>
                            <div className="row justify-content-between">
                                <div className="col-5 lp-career-block lp-career-bg-Dorange">
                                    <p className="lp-career-text">スペシャリスト</p>
                                </div>
                                <div className="col-5 lp-career-block lp-career-bg-pink">
                                    <p className="lp-career-text">
                                        PL <br />
                                        <span className="lp-career-subtxt">(プロジェクトリーダー)</span> <br />
                                        小規模案件
                                    </p>
                                </div>
                            </div>
                            <div className="lp-node-2_2"></div>
                            <div className="row justify-content-between">
                                <div className="col-5"></div>
                                <div className="col-5 lp-career-block lp-career-bg-pink">
                                    <p className="lp-career-text">
                                        PM <br />
                                        <span className="lp-career-subtxt">(プロジェクトマネージャー)</span> <br />
                                        大規模案件
                                    </p>
                                </div>
                            </div>
                            <div className="lp-node-2_2"></div>
                            <div className="row justify-content-between">
                                <div className="col-5"></div>
                                <div className="col-5">
                                    <p className="lp-career-text">
                                        経営陣 <br />
                                        <span className="lp-career-subtxt">(会社の方針決定)</span>
                                    </p>
                                </div>
                            </div>
                            {/* red box  */}
                            <div className="lp-node-2_2"></div>
                            <div className="row justify-content-between">
                                <div className="col-5"></div>
                                <div className="col-5 lp-career-block lp-career-bg-red">
                                    <p className="lp-career-text">部長兼PM</p>
                                </div>
                            </div>
                            <div className="lp-node-2_2"></div>
                            <div className="row justify-content-between">
                                <div className="col-5"></div>
                                <div className="col-5 lp-career-block lp-career-bg-red">
                                    <p className="lp-career-text">統括部長</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* section 5 */}
                    <div className="sec sec05 lp-noto">
                        <div className="sec-inner_2">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec05_ttl} alt="model-title" className="img-fluid" />
                                <span>ある社員の一日</span>
                            </h2>
                            <div className="lp-employee-sec05 row mt-5 ">
                                <div className="ps-0 col-12 mt-5">
                                    <p className="lp-intro-txt">システム部 (2017年入社)</p>
                                    <p className="lp-intro-txt_2 text-blue">K. YUNA</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_700} alt="oneday-700" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_700time} alt="time-700" className="lp-model-img" /><span className="lp-time-text">起床</span></p>
                                    <p className="lp-time-detail">毎日昼ご飯にお弁当を作っているので、寝坊しないように気を付けてます。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_830} alt="oneday-830" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_830time} alt="time-830" className="lp-model-img" /><span className="lp-time-text">出勤</span></p>
                                    <p className="lp-time-detail">まずはメールを確認して、チーム定例まで個人作業を進めます。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_1030} alt="oneday-1030" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_1030time} alt="time-1030" className="lp-model-img" /><span className="lp-time-text">チーム定例</span></p>
                                    <p className="lp-time-detail">一段落してきたら、チーム内でタスクの確認をします。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_1145} alt="oneday-1145" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_1145time} alt="time-1145" className="lp-model-img" /><span className="lp-time-text">昼食</span></p>
                                    <p className="lp-time-detail">持参したお弁当を食べて、休憩をとって午後に備えます。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_1245} alt="oneday-1245" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_1245time} alt="time-1245" className="lp-model-img" /><span className="lp-time-text">個人作業</span></p>
                                    <p className="lp-time-detail">問い合わせの対応もしながら、個人作業を進めています。丸一日問い合わせ対応の日もあります。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_1730} alt="oneday-1730" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_1730time} alt="time-1730" className="lp-model-img" /><span className="lp-time-text">チーム定例～退勤</span></p>
                                    <p className="lp-time-detail">一日の進捗状況をチーム内で確認します。明日の予定もここで確認。定時退社はこの時間となります。</p>
                                </div>
                            </div>
                            <div className="row lp-oneday-detail">
                                <div className="ps-0 col-4">
                                    <img src={lpSec05_1900} alt="oneday-1900" className="model-img" />
                                </div>
                                <div className="col-8 pt-3 pb-3">
                                    <p><img src={lpSec05_1900time} alt="time-1900" className="lp-model-img" /><span className="lp-time-text">残作業がある場合</span></p>
                                    <p className="lp-time-detail">日によって残作業がある場合は、このくらいの時間になることもあります。</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 6 */}
                    <div className="sec sec06 lp-noto">
                        <div className="sec-inner_2">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec06_ttl} alt="interview-title" className="img-fluid" />
                                <span>先輩社員の声</span>
                            </h2>
                            <div className="lp-employee-sec06 row">
                                <div className="ps-0 col-12 mt-5">
                                    <p className="lp-intro-txt">システム部 (2018年入社)</p>
                                    <p className="lp-intro-txt_2 text-blue">Y. KIKUNO</p>
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        入社のきっかけはなんですか？
                                    </p>
                                    <p className="lp-ans">
                                        企業説明会に行ったときに当社の話を聞いて、人事の人当りの良さと会社の雰囲気に惹かれて入社しました。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        会社の雰囲気はどうですか？
                                    </p>
                                    <p className="lp-ans">
                                        上下間でも和気あいあいとしており、意見を言いやすく、また、通りやすい雰囲気だと思います。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        入社後、スキルアップできた内容はなんですか？
                                    </p>
                                    <p className="lp-ans">
                                        文系出身でプログラムを全然やったことがなかったのですが、上司や周りの人たちに支えられて、徐々にできるようになってきました。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        入社後、自分が成長したと感じる点は？
                                    </p>
                                    <p className="lp-ans">
                                        仕事の要点が分かってきて、仕様で気になるところや疑問点を投げかけることができるようになってきました。<br />
                                        あと、人前に出ることがあまり得意ではなかったのですが、<br />
                                        何回か発言する機会をいただき、最近では上司の方々にも褒められるようになりました！

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 6_02 */}
                    <div className="sec sec06_02 lp-noto">
                        <div className="sec-inner_2">
                            <div className="lp-employee-sec06_02 row mt-5">
                                <div className="ps-0 col-12 mt-5">
                                    <p className="lp-intro-txt">システム部 (2015年入社)</p>
                                    <p className="lp-intro-txt_2 text-blue">U. TADASHI</p>
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        入社後、スキルアップできた内容はなんですか？
                                    </p>
                                    <p className="lp-ans">
                                        この仕事では様々なプログラム言語に触れる機会があります。
                                        これまでの業務経験から、そういったプログラムを読み解く力は向上した実感があります。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        入社後、自分が成長したと感じる点は？
                                    </p>
                                    <p className="lp-ans">
                                        仕事の進め方です。仕事をこなすうえで、計画をたてて実績を報告するというサイクルを、
                                        無意識的に実践できるようになった点は、自分でも成長したなと感じます。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        NALに向いている人ってどんな人？
                                    </p>
                                    <p className="lp-ans">
                                        自分が持った疑問を、納得のいく結論まで突き詰めることができる人です。
                                        親身に相談に乗ってくれる先輩は多いですよ。
                                    </p>
                                </div>
                                <div className="col-12 p-5">
                                    <p className="lp-qa">
                                        <img src={lpSec06_q} alt="question" className="qa-img" />
                                        これからNALでチャレンジしてみたいことは？
                                    </p>
                                    <p className="lp-ans">
                                        今後は営業職にも、ぜひチャレンジしてみたいです！
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 7 */}
                    <div className="sec sec07">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec07_ttl} alt="benefits-title" className="img-fluid" />
                                <span>福利厚生・研修</span>
                            </h2>
                            <div className="row mt-5">
                                <div className="col-12 mt-5 mb-5 benefit-list">
                                    <img src={lpSec07_benefit01} alt="benefits" className="benefit-img" />
                                    <div className="benefits-content">
                                        <h3 className="lp-benefit-title text-blue">
                                            株式会社 富士通ラーニングメディア<br />
                                            名古屋ラーニングセンター
                                        </h3>
                                        <p className="lp-benefit-txt">
                                            名古屋ラーニングセンターは東海地区の研修拠点です。講師・スタッフの、
                                            受講生の方へのサービスの充実はもとより、
                                            リラクゼーションを意識したラウンジやバリアフリーを取り入れるなど
                                            「人への優しさ」を意識した施設作りになっています。
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 mt-5 mb-5 benefit-list">
                                    <img src={lpSec07_benefit02} alt="benefits" className="benefit-img" />
                                    <div className="benefits-content">
                                        <h3 className="lp-benefit-title text-blue">
                                            福利厚生倶楽部
                                        </h3>
                                        <p className="lp-benefit-txt">
                                            旅行・レジャー・グルメなどの余暇支援サービスや、育児や介護、
                                            メンタルケアなどのワークライフバランス
                                            の両立につながるサービスをご提供する福利厚生の代行サービスです。
                                            従業員とそのご家族もご利用でき、様々なサービスを
                                            市場価格より割引した価格でご利用が可能です。
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 mt-5 mb-5 benefit-list">
                                    <img src={lpSec07_benefit03} alt="benefits" className="benefit-img" />
                                    <div className="benefits-content">
                                        <h3 className="lp-benefit-title text-blue">
                                            社員旅行
                                        </h3>
                                        <p className="lp-benefit-txt">
                                            社員間の親睦を深めるために、おおよそ２年に１回の割合で行っています。
                                            行先は国内、社員アンケートで決まります。
                                            最近では京都（市内・嵐山）、北陸（兼六園・山中温泉）、
                                            東京（東京スカイツリー・屋形船）などです。
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 mt-5 mb-5 benefit-list">
                                    <img src={lpSec07_benefit04} alt="benefits" className="benefit-img" />
                                    <div className="benefits-content">
                                        <h3 className="lp-benefit-title text-blue">
                                            社内サークル
                                        </h3>
                                        <p className="lp-benefit-txt">
                                            先輩、後輩、年齢、役職など関係なく、
                                            同じ趣味などを持った社員同士が集まり楽しんでいます。
                                            ロボ部、釣り部、企画部などがあり、
                                            新しいサークルが出来るのを楽しみにしています。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* section 8 */}
                    <div className="sec sec08" id="lp-entry">
                        <div className="sec-inner">
                            <h2 className="lp-service-subhead mb-5">
                                <img src={lpSec08_ttl} alt="recruit-title" className="img-fluid" />
                                <span>採用情報</span>
                            </h2>
                            <div className="row mt-5 mb-5">
                                <div className="col-12 mt-5 mb-5 lp-recruit-img">
                                    <img src={lpSec08_main} alt="recruit-title" className="lp-recruit-main" />
                                </div>
                                <table className="lp-recruit-details">
                                    <tbody>
                                        <tr>
                                            <th>募集職種</th>
                                            <td>システムエンジニア</td>
                                        </tr>

                                        <tr>
                                            <th>応募資格</th>
                                            <td>2022年3月に大学院・大学<br />
                                                ・専門学校を卒業見込みの方</td>
                                        </tr>

                                        <tr>
                                            <th>募集人員</th>
                                            <td>5名</td>
                                        </tr>

                                        <tr>
                                            <th>基本給</th>
                                            <td>214,000円：大学院卒<br />
                                                210,000円：大学卒<br />
                                                197,000円：専門課程(4年)卒<br />
                                                195,000円：専門課程(3年)卒<br />
                                                193,000円：専門課程(2年)卒<br />
                                                ※試用期間3ヶ月(待遇の変更無し)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <a className="lp-recruit-button" rel="noreferrer" href="https://job.mynavi.jp/22/pc/search/corp242975/outline.html" target="_blank">
                                エントリーはこちらから
                            </a>

                        </div>
                    </div>

                    {/* footer */}
                    <footer className="lp-footer">© NAL Software Co., Ltd. All Rights Reserved</footer>

                </div>
                {/* </div> */}
            </React.Fragment>
        )
    }
}

export default LandingPage;
